<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>
          {{ $t('mEditionProductPagesOfGratefulnessModalUndefined.title') }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mEditionProductPagesOfGratefulnessModalUndefined.messageUndefined.first') }}
        </p>
        <small class="font-weight-bold text-color-billing-primary">
          {{ $t('mEditionProductPagesOfGratefulnessModalUndefined.messageUndefined.second') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductPagesOfGratefulnessModalUndefined',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionProductPagesOfGratefulnessModalUndefined.buttonPrimary'),
        class: 'a-button-products-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
